module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Regular.9adcda4.woff2";